import styled from 'styled-components'

export const SlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .icon-header {
    margin-bottom: 17px;
    font-weight: 700 !important;
    color: #3a3a3a !important;
    font-size: 18px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    > svg {
      margin-right: 8px;
    }
  }
`

export const TitleText = styled.div`
  border-bottom: 2px solid rgba(123, 123, 123, 0.23);
  width: 100%;
  text-align: center;
  padding: 1.1rem 0;
  font-size: 22px;
  font-weight: 700;
  color: #353535;
`

export const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 16px;
  padding: 16px 2rem 32px;
  box-sizing: border-box;

  justify-content: ${({ leftAlign }) => (leftAlign ? 'flex-start' : 'center')};
  width: 100%;
  padding-bottom: 32px;
  .profile-text {
    font-size: 19px;
    font-weight: 300;
    margin-left: 2rem;
    display: block;
    > * {
      max-width: 170px;
    }
  }
  .profile-name {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 2px;
  }

  .paras {
    margin-left: 18px;
    font-size: 18px;
    @media only screen and (max-width: 500px) {
      font-size: 17px;
    }
    > p {
      color: #949494;
      font-weight: 500;
      > span {
        color: black;
        font-weight: 700;
      }
    }
  }

  @media only screen and (max-width: 500px) {
    padding: ${({ mobilePad }) => mobilePad || '16px 0.2rem 32px'};
    .profile-name {
      font-size: 18px;
    }
    .profile-text {
      font-size: 17px;
    }
  }
`

export const SlideBody = styled.div`
  font-size: 18px;
  margin: 0 2rem;
  .body-head {
    font-weight: 500;
    color: #000000;
    margin-bottom: 24px;
  }
`

export const TargetsSection = styled.div`
  text-align: center;
  font-size: 18px;

  span {
    color: black;
    font-weight: 700;
  }

  > p {
    color: #949494;
    font-weight: 500;
    margin-bottom: 4px;
    @media only screen and (max-width: 580px) {
      text-align: center !important;
      font-size: 17px !important;
    }
  }
`

export const DesiredSkillsSection = styled.div`
  margin-top: 32px;
  ${({ singleRow }) => singleRow && 'margin-top: 40px;'}
  > ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    > li {
      display: flex;
      flex-direction: column;
      white-space: pre-line;
      text-align: center;
      align-items: center;
      font-weight: 500;
      min-width: 112px;
      ${({ singleRow }) => singleRow && 'min-width: 75px;'}
      @media only screen and (max-width: 500px) {
        min-width: 85px;
        font-size: 12px;
        ${({ singleRow }) => singleRow && 'min-width: 60px'}
      }

      font-size: 14px;
      margin: 16px 0;
      > svg {
        margin-bottom: 10px;
        ${({ singleRow }) => singleRow && 'width: 56px; height: 56px;'}
        @media only screen and (max-width: 500px) {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
`
